import { Component, Injector, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideNavBarComponent } from '../../side-nav-bar/side-nav-bar.component';
import { MainLayoutPageComponent } from 'src/app/shared/component/main-layout-page/main-layout-page.component';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { NavBarService } from 'src/app/shared/services/nav-bar.service';
import { RouterComponent } from 'src/app/shared/component/router/router.component';
import { MinimalHeaderComponent } from '../minimal-header/minimal-header.component';
import { AppBloc, InitApplicationTheme, ThemeReadyState } from 'src/app/shared/bloc/app-bloc';
import { takeUntil } from 'rxjs';
import { BlocState, InitEvent } from 'src/app/shared/bloc/base-bloc';
import { ThemesService } from 'src/app/core/services/themes.service';

@Component({
  selector: 'app-minimal-layout-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    SideNavBarComponent,
    MinimalHeaderComponent,
    MainLayoutPageComponent,
    RouterComponent
  ],
  templateUrl: './minimal-layout.component.html',
  styleUrls: ['./minimal-layout.component.scss']
})
export class MinimalLayoutComponent extends BaseComponent implements OnInit {

  //getters
  get isCollapsed(): boolean {
    return this.injector.get(NavBarService).isSideNavCollapsed;
  }

  constructor(
    injector: Injector, 
    private appBloc: AppBloc,
    private themeService: ThemesService) { 
    super([], injector);
    this.appBloc.onState.pipe(takeUntil(this.destroy$)).subscribe(state => this.onHandleAppBlocState(state));
  }

  ngOnInit(): void {
   this.initTheme();
   this.getAuthenticatedUserData();
  }

  private initTheme(): void {
    if(this.themeService.currentTheme != this.themeService.defaultTheme) {
      this.appBloc.setEvent.next(new InitApplicationTheme());
    }
  }

  private getAuthenticatedUserData(): void {
    this.appBloc.setEvent.next(new InitEvent());
  }
  
  private onHandleAppBlocState(state: BlocState): void {
    if (state instanceof ThemeReadyState) {
      this.themeService.setTheme(state.theme);
    }
  }
}
